export const SPEECH_ENGINES = {
    WEB_SPEECH: 'web_speech',
    ELEVENLABS: 'elevenlabs',
};

export const LANGUAGE_CONFIG = {
    en: {
        speechEngine: SPEECH_ENGINES.WEB_SPEECH,
        speechLocale: 'en-US',
        requiresLogin:false
    },

    fil: {
        speechEngine: SPEECH_ENGINES.ELEVENLABS,
        speechLocale: 'fil-PH',
        voiceId: 'DxICOrDlizHfox9uSCDm',
        requiresLogin:true
    },
};